export default __webpack_public_path__ + "static/media/heroBg.d920a3c8.jpg";